// Layout for the /secrets subtree: index = list, $secretId = detail.

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets",
)({
  component: () => <Outlet />,
});
